import type { IncomingMessage } from 'http';
import { DEFAULT_LOCALE } from '@/constants';

// import { mapCountryToLocale } from './mapCountryToLocale';

export const getLocaleFromRequest = async (
	query: { lang?: string; locale?: string },
	// Keep signature for backward compatibility – cookies are ignored to avoid redirect loops
	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	cookies: string,
	req?: IncomingMessage,
): Promise<string> => {
	// Priority: locale from pathname > lang param (legacy) > CloudFront geo-detection
	const localeFromPath = (query?.locale as string)?.trim() ?? '';
	const langFromQuery = (query?.lang as string)?.trim() ?? '';

	// If we have explicit locale from pathname or query param, use it (NEVER use CloudFront in this case)
	if (localeFromPath) {
		return localeFromPath;
	}
	if (langFromQuery) {
		return langFromQuery;
	}

	// let geoCountry = '';

	// Try to get country from CloudFront header
	// if (!geoCountry && req) {
	// 	try {
	// 		const hostname = req.headers.host || '';
	//
	// 		// For localhost in development, use mocked country code if set, otherwise default to English locale (US)
	// 		if (
	// 			process.env.NODE_ENV === 'development' &&
	// 			(hostname === 'localhost' ||
	// 				hostname.includes('127.0.0.1') ||
	// 				hostname.includes('localhost:'))
	// 		) {
	// 			// Allow mocking CloudFront country code via environment variable for local development
	// 			geoCountry =
	// 				process.env.MOCK_CLOUDFRONT_COUNTRY?.toUpperCase().trim() || 'US';
	// 		} else {
	// 			// Get country code from CloudFront-Viewer-Country header
	// 			// CloudFront adds this header automatically, but the name might vary
	// 			// Standard name is "CloudFront-Viewer-Country" but Node.js might convert headers to lowercase
	// 			// Try different possible header names (case-insensitive)
	// 			const cloudFrontCountry =
	// 				req.headers['cloudfront-viewer-country'] ||
	// 				req.headers['cloudfront-viewer-country-code'] ||
	// 				req.headers['cf-viewer-country'] ||
	// 				req.headers['x-cloudfront-viewer-country'] ||
	// 				req.headers['CloudFront-Viewer-Country'];
	//
	// 			if (cloudFrontCountry) {
	// 				const country = Array.isArray(cloudFrontCountry)
	// 					? cloudFrontCountry[0]
	// 					: cloudFrontCountry;
	// 				geoCountry = country.toUpperCase().trim();
	// 			}
	// 		}
	// 	} catch (e) {
	// 		// Silently handle errors
	// 	}
	// }

	// Determine locale based on country
	// if (geoCountry) {
	// 	return mapCountryToLocale(geoCountry);
	// }

	return DEFAULT_LOCALE;
};
